import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateObjectValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

import type { EngagementDescription } from "../../types/description.dto";
import type { IEngagementFilterDto } from "../../types/leadsSearchFilters.dto";

export default class FindEngagementFilter extends FilterPanelBaseFilter<IEngagementFilterDto, EngagementDescription> {
    constructor(deps: IFilterPanelBaseFilterDeps<IEngagementFilterDto, EngagementDescription>) {
        super(deps);
    }

    isFilterDirty(currentValue: IEngagementFilterDto | undefined): boolean {
        return JSON.stringify(this.initialDtoValue ?? {}) !== JSON.stringify(currentValue ?? {});
    }

    calculateValueDelta(
        previousValue: IEngagementFilterDto | undefined,
        newValue: IEngagementFilterDto | undefined,
    ): FilterValueDelta<IEngagementFilterDto> {
        return calculateObjectValueDelta<Partial<IEngagementFilterDto>>(previousValue, newValue);
    }
}
